import { useGallery, useWindowEvent, AspectRatio } from '@ccg/core';
import React$1, { useState, useRef, useEffect } from 'react';
import PropTypes$1 from 'prop-types';
import Icon$1 from '../../basics/Icon/Icon.js';
import MediaContent$1 from '../MediaContent/MediaContent.js';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import Controls$1 from './subcomponents/Controls/Controls.js';
import StyledGallery, { GalleryLine } from './Gallery.style.js';
import Slider$1 from './subcomponents/Slider/Slider.js';
import Overview$1 from './subcomponents/Overview/Overview.js';
import Modal$1 from '../Modal/Modal.js';

const Gallery = ({
  images,
  caption
}) => {
  const {
    index,
    isOverview,
    handlePrev,
    handleNext,
    handleChange,
    toggleOverview
  } = useGallery(images);
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);
  useWindowEvent('keydown', ({
    key
  }) => {
    if (key === 'ArrowRight') return handleNext();
    if (key === 'ArrowLeft') return handlePrev();
    if (key === 'o') return toggleOverview();
    if (key === 'Escape') return setIsOpen(false);
  });
  useEffect(() => {
    if (isOpen) {
      disableBodyScroll(ref.current);
    } else {
      enableBodyScroll(ref.current);
    }

    return () => {
      clearAllBodyScrollLocks();
    };
  }, [isOpen]);
  const maxRatio = {
    width: Math.max(...images.map(item => item.width)),
    height: Math.max(...images.map(item => item.height))
  };
  return /*#__PURE__*/React$1.createElement(StyledGallery, null, /*#__PURE__*/React$1.createElement(MediaContent$1, {
    caption: `<p> ${index + 1}<span>/${images.length}</span></p><br/>${caption || ''}`,
    variant: "xl",
    noReveal: true
  }, /*#__PURE__*/React$1.createElement(AspectRatio, {
    ratio: `${maxRatio.width}:${maxRatio.height}`
  }, /*#__PURE__*/React$1.createElement(Slider$1, {
    overview: false,
    images: images,
    currentIndex: index,
    handleChange: handleChange,
    setIsOpen: setIsOpen
  })), /*#__PURE__*/React$1.createElement("button", {
    type: "button",
    onClick: () => handlePrev(),
    className: "gallery__prev",
    "aria-label": "Prev"
  }, /*#__PURE__*/React$1.createElement(Icon$1, {
    icon: "leftArrow",
    alignment: "left"
  })), /*#__PURE__*/React$1.createElement("button", {
    type: "button",
    onClick: () => handleNext(),
    className: "gallery__next",
    "aria-label": "Next"
  }, /*#__PURE__*/React$1.createElement(Icon$1, {
    icon: "rightArrow",
    alignment: "right"
  }))), /*#__PURE__*/React$1.createElement(Modal$1, {
    className: "gallery__modal",
    isOpen: isOpen,
    ref: ref,
    flex: true
  }, /*#__PURE__*/React$1.createElement(GalleryLine, null), !isOverview && images.length > 0 && /*#__PURE__*/React$1.createElement(Slider$1, {
    images: images,
    currentIndex: index,
    handleChange: handleChange
  }), isOverview && images.length > 0 && /*#__PURE__*/React$1.createElement(Overview$1, {
    images: images,
    currentIndex: index,
    handleChange: handleChange
  }), /*#__PURE__*/React$1.createElement(Controls$1, {
    isOverview: isOverview,
    handleNext: handleNext,
    handlePrevious: handlePrev,
    handleClose: () => setIsOpen(false),
    handleOverview: () => toggleOverview(),
    handleChange: handleChange,
    currentIndex: index,
    currentCaption: images[index] && images[index].caption,
    numberOfBullets: images.length
  })));
};

Gallery.propTypes = {
  caption: PropTypes$1.string,
  images: PropTypes$1.arrayOf(PropTypes$1.shape()).isRequired
};
Gallery.defaultProps = {
  caption: null
};

export default Gallery;
